<div class="admin-content">
  <cei-admin-page-cabecalho titulo="Detalhes do Grupo" [rotaVoltar]="'/admin/grupos'" />
  @if (grupo(); as grupo) {
    <cei-panel class="admin-form-panel" [height]="'auto'">
      <table class="admin-detail-table">
        <tbody>
          <tr>
            <th scope="row">ID</th>
            <td>{{ grupo.id }}</td>
          </tr>
          <tr>
            <th scope="row">Nome</th>
            <td>{{ grupo.name }}</td>
          </tr>
        </tbody>
      </table>
    </cei-panel>
    <div class="admin-content__actions" [routerLink]="['/admin/grupos/atualizar', grupo.id]">
      <cei-button type="button">Editar</cei-button>
    </div>
  }
</div>
